import React from "react";
import { Box } from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";

const DetailPageLoading = () => {
  return (
    <Box sx={{ height: "50vh" }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <CircularProgress color="primary" fontSize={"medium"} />
      </Box>
    </Box>
  );
};

export default DetailPageLoading;
